import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-no-content',
  templateUrl: './no-content.component.html',
  styleUrls: ['./no-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe]
})
export class NoContentComponent {
  readonly headline = input<string>(undefined);
  readonly message = input<string>(undefined);
  readonly hideImage = input<boolean>(undefined);
  readonly transparent = input<boolean>(undefined);
  readonly withoutVerticalSpacing = input<boolean>(false);
}
